import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { usePopper } from 'react-popper';

import checkmark from '@coursera/assets/icons/check-mark.svg';
import info from '@coursera/assets/icons/hotspot-tooltip-info.svg';

import { customTypes } from '../helpers';
import { Button, MaterialModal } from '../index';

import styles from './hotspot.module.scss';

const cx = classnames.bind(styles);

function HotSpot({ dimensions, isComplete, left, modal, onDone, top, tooltip }) {
  const [complete, setComplete] = useState(isComplete);
  const [modalOpen, setModalOpen] = useState(false);
  const [trigger, setTrigger] = useState(null);

  const closeModal = () => {
    setModalOpen(false);
    setComplete(true);
    onDone();
  };

  return (
    <div className={cx({ 'step-complete': complete })}>
      {dimensions && (
        <div
          className={styles.hotspot}
          style={{
            top: top * dimensions.height,
            left: left * dimensions.width,
          }}
          ref={setTrigger}
        >
          <Button
            variant="text"
            onClick={() => setModalOpen(true)}
            aria-label={!complete ? modal.title : null}
          >
            {complete ? (
              <img src={checkmark} alt="step complete" />
            ) : (
              <img src={info} alt="step incomplete" />
            )}
          </Button>
          {tooltip && (
            <SpotTip
              complete={complete}
              trigger={trigger}
              click={() => setModalOpen(true)}
              {...tooltip}
            />
          )}
          <MaterialModal
            open={modalOpen}
            ctaText={modal.ctaText}
            closeModal={closeModal}
            image={modal.image}
          >
            <div>
              <h6>{modal.title}</h6>
              <div className={styles['modal-content']}>{modal.text}</div>
            </div>
          </MaterialModal>
        </div>
      )}
    </div>
  );
}

HotSpot.propTypes = {
  dimensions: PropTypes.object,
  isComplete: PropTypes.bool,
  left: PropTypes.number.isRequired,
  modal: PropTypes.shape({
    ctaText: PropTypes.string,
    image: customTypes.image,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.string,
  }),
  onDone: PropTypes.func,
  tooltip: PropTypes.any,
  top: PropTypes.number.isRequired,
};

HotSpot.defaultProps = {
  isComplete: false,
  onDone: () => {},
};

export default HotSpot;

function SpotTip({ offset, position, style, text, complete, click, trigger, alternate, xl }) {
  const popperElement = useRef(null);

  const { styles: popperStyles, attributes } = usePopper(trigger, popperElement.current, {
    placement: position,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: offset,
        },
      },
      {
        name: 'flip',
        options: {
          fallbackPlacements: [position],
        },
      },
      {
        name: 'preventOverflow',
        options: {
          mainAxis: false,
        },
      },
    ],
  });

  console.log('xl', xl);

  return (
    <div
      ref={popperElement}
      className={cx({ tooltip: 1, alternate: alternate, xl: xl })}
      style={popperStyles.popper}
      onClick={click}
      {...attributes.popper}
    >
      <div className={cx({ 'step-complete': complete })} style={style}>
        {text}
      </div>
    </div>
  );
}

SpotTip.propTypes = {
  offset: PropTypes.arrayOf(PropTypes.number),
  position: PropTypes.string,
  style: PropTypes.any,
  text: PropTypes.string,
  complete: PropTypes.bool,
  alternate: PropTypes.bool,
  xl: PropTypes.bool,
  click: PropTypes.func,
  trigger: PropTypes.instanceOf(Element),
};

SpotTip.defaultProps = {
  offset: [0, 0],
  position: 'top',
  style: {},
};
